// Generated by CoffeeScript 1.12.7 — converted to ESM
var CHECKPOINT_PREFIX = '#!%!'
var CHECKPOINT_SUFFIX = '!%!#'

export var CHECKPOINT_PATTERN = new RegExp(CHECKPOINT_PREFIX + '\\d+' + CHECKPOINT_SUFFIX, 'g')

var QUOTE_IDS = ['OLK_SRC_BODY_SECTION']

// body는 기존 구현에서도 양 끝 공백을 추가하지 않았다(루트 래퍼이기 때문).
// HTML 파서의 "in table/in row/in select/..." insertion mode 규칙상,
// 공백-only character 토큰은 foster-parenting 없이 현재 노드에 직접 삽입되므로
// table 계열 태그에서도 기존 innerHTML 재파싱 경로와 동일하게 공백 TextNode가 추가된다.
// 따라서 추가로 제외할 태그는 없다.
function shouldSkipTextWrap(htmlNode) {
  return htmlNode.tagName.toLowerCase() === 'body'
}

// 기존 경로는 `innerHTML` 왕복으로 인접 TextNode가 자동 병합되었다.
// 동일 효과를 내도록 양 끝 공백을 붙이되, firstChild/lastChild가 TextNode면
// 그 nodeValue에 직접 이어붙인다. TextNode가 아니면 별도 공백 노드를 끼운다.
function padElementWithWhitespace(htmlNode) {
  var doc = htmlNode.ownerDocument
  var first = htmlNode.firstChild
  if (first != null && first.nodeType === 3) {
    first.nodeValue = '  ' + first.nodeValue
  } else {
    htmlNode.insertBefore(doc.createTextNode('  '), first)
  }
  var last = htmlNode.lastChild
  if (last != null && last.nodeType === 3) {
    last.nodeValue = last.nodeValue + '  '
  } else {
    htmlNode.appendChild(doc.createTextNode('  '))
  }
}

export function createEmailDocument(msgBody, dom) {
  var emailBodyElement, emailDocument, head, htmlElement, i, styleEls
  emailDocument = dom.implementation.createHTMLDocument()
  htmlElement = emailDocument.getElementsByTagName('html')[0]
  htmlElement.innerHTML = msgBody.trim()
  if (emailDocument.body == null) {
    emailBodyElement = emailDocument.getElementsByTagName('body')[0]
    emailDocument.body = emailBodyElement
  }
  head = emailDocument.getElementsByTagName('head')[0]
  if (head) {
    // head의 <style>은 본문 스타일(클래스 등) 정의에 필요하므로 출력에 재부착하기 위해 보존한다.
    // (분석에는 영향을 주지 않도록 head 제거 후 별도 보관만 하고, body에는 넣지 않는다.)
    styleEls = head.getElementsByTagName('style')
    emailDocument.planerSavedStyles = []
    for (i = 0; i < styleEls.length; i++) {
      emailDocument.planerSavedStyles.push(styleEls[i].cloneNode(true))
    }
    emailDocument.documentElement.removeChild(head)
  }
  return emailDocument
}

// createEmailDocument가 보존한 head <style>을 출력용 body 맨 앞에 재부착한다.
// (분석 단계 이후 출력 직전에만 호출 — 체크포인트/라인 분석에는 영향 없음)
export function reattachSavedStyles(sourceDocument, targetDocument) {
  var styles = sourceDocument.planerSavedStyles
  if (styles == null || styles.length === 0 || targetDocument.body == null) {
    return
  }
  var i, imported
  for (i = styles.length - 1; i >= 0; i--) {
    imported = targetDocument.importNode(styles[i], true)
    targetDocument.body.insertBefore(imported, targetDocument.body.firstChild)
  }
}

// importNode 기반 Document 복제. 원본 <html>의 자식 중 body와 Comment 노드만 순서대로 복제한다.
// (일반적으로 html 직계 자식은 head/body 뿐이지만, </body> 뒤의 주석은 HTML 파서가 html의 자식으로
// 삽입한다. 기존 `createEmailDocument(outerHTML)` 경로는 재파싱을 통해 이 주석도 보존했다.)
export function cloneEmailDocument(srcDocument, dom) {
  var emailDocument, newHtml, srcHtml, i, len, children, child
  emailDocument = dom.implementation.createHTMLDocument()
  newHtml = emailDocument.getElementsByTagName('html')[0]
  while (newHtml.firstChild) {
    newHtml.removeChild(newHtml.firstChild)
  }
  srcHtml = srcDocument.documentElement
  children = Array.prototype.slice.call(srcHtml.childNodes)
  for (i = 0, len = children.length; i < len; i++) {
    child = children[i]
    // body(Element) 또는 Comment(nodeType 8)만 복제. head 등 기타는 제외.
    if (child.nodeType === 8 || child === srcDocument.body) {
      newHtml.appendChild(emailDocument.importNode(child, true))
    }
  }
  return emailDocument
}

export function addCheckpoints(htmlNode, counter) {
  var childNode, i, len, ref
  if (htmlNode.nodeType === 3) {
    htmlNode.nodeValue =
      '' + htmlNode.nodeValue.trim() + CHECKPOINT_PREFIX + counter + CHECKPOINT_SUFFIX + '\n'
    counter++
  }
  if (htmlNode.nodeType === 1) {
    if (!shouldSkipTextWrap(htmlNode)) {
      padElementWithWhitespace(htmlNode)
    }
    ensureTextNodeBetweenChildElements(htmlNode)
    ref = Array.prototype.slice.call(htmlNode.childNodes)
    for (i = 0, len = ref.length; i < len; i++) {
      childNode = ref[i]
      counter = addCheckpoints(childNode, counter)
    }
  }
  return counter
}

export function deleteQuotationTags(htmlNode, counter, quotationCheckpoints) {
  var childNode, childTagInQuotation, i, j, len, len1, quotationChildren, ref, ref1, tagInQuotation
  tagInQuotation = true
  if (htmlNode.nodeType === 3) {
    if (!quotationCheckpoints[counter]) {
      tagInQuotation = false
    }
    counter++
    return [counter, tagInQuotation]
  }
  if (htmlNode.nodeType === 1) {
    childTagInQuotation = false
    quotationChildren = []
    if (!shouldSkipTextWrap(htmlNode)) {
      padElementWithWhitespace(htmlNode)
    }
    ensureTextNodeBetweenChildElements(htmlNode)
    ref = Array.prototype.slice.call(htmlNode.childNodes)
    for (i = 0, len = ref.length; i < len; i++) {
      childNode = ref[i]
      ;((ref1 = deleteQuotationTags(childNode, counter, quotationCheckpoints)),
        (counter = ref1[0]),
        (childTagInQuotation = ref1[1]))
      tagInQuotation = tagInQuotation && childTagInQuotation
      if (childTagInQuotation) {
        quotationChildren.push(childNode)
      }
    }
  }
  if (tagInQuotation) {
    return [counter, tagInQuotation]
  } else {
    for (j = 0, len1 = quotationChildren.length; j < len1; j++) {
      childNode = quotationChildren[j]
      htmlNode.removeChild(childNode)
    }
    return [counter, tagInQuotation]
  }
}

// ── 인용 구간 구조적 cut (OFM-232) ──────────────────────────────────────────
// deleteQuotationTags는 텍스트 노드만 지워 껍데기(<p>/<br>/<div>)·이미지·헤더가 남는다.
// 인용이 문서 끝까지 이어지는 경우(toEnd), 인용 시작 노드를 찾아 그 지점부터 문서 끝까지 DOM을
// 구조적으로 잘라낸다. readReceipt 추적 픽셀 등 비인용 요소는 보존한다.
// (중간 제거(middle) 케이스는 기존 deleteQuotationTags 텍스트 제거를 그대로 사용한다.)

var READ_RECEIPT_IMG_SELECTOR = 'img[src*="readReceipt"]'

// addCheckpoints/deleteQuotationTags와 동일한 패딩·순회로 counter를 정합시키며
// 첫 인용 텍스트 노드를 찾는다.
function findFirstQuotationNode(htmlNode, counterRef, quotationCheckpoints) {
  var childNode, found, i, len, ref
  if (htmlNode.nodeType === 3) {
    var isQuotation = !!quotationCheckpoints[counterRef.counter]
    counterRef.counter++
    return isQuotation ? htmlNode : null
  }
  if (htmlNode.nodeType === 1) {
    if (!shouldSkipTextWrap(htmlNode)) {
      padElementWithWhitespace(htmlNode)
    }
    ensureTextNodeBetweenChildElements(htmlNode)
    ref = Array.prototype.slice.call(htmlNode.childNodes)
    for (i = 0, len = ref.length; i < len; i++) {
      childNode = ref[i]
      found = findFirstQuotationNode(childNode, counterRef, quotationCheckpoints)
      if (found != null) {
        return found
      }
    }
  }
  return null
}

// node 앞에 (공백 아닌) 형제가 없는 가장 높은 조상을 반환.
// 텍스트 노드에서 시작해 이를 감싼 <p>/<div> 컨테이너까지 올려 통째로 잘라내기 위함.
// 앞에 인용 밖(답장) 내용이 있으면 그 지점에서 멈춰 답장을 보존한다.
function highestQuotationStart(node, emailBody) {
  var start = node
  var sibling, hasContentBefore
  while (
    start.parentNode != null &&
    start.parentNode !== emailBody &&
    start.parentNode.nodeType === 1
  ) {
    sibling = start.previousSibling
    hasContentBefore = false
    while (sibling != null) {
      if (!(sibling.nodeType === 3 && sibling.nodeValue.trim() === '')) {
        hasContentBefore = true
        break
      }
      sibling = sibling.previousSibling
    }
    if (hasContentBefore) {
      break
    }
    start = start.parentNode
  }
  return start
}

function isHiddenTable(element) {
  if (element.nodeType !== 1 || element.tagName.toLowerCase() !== 'table') {
    return false
  }
  var style = element.getAttribute('style') || ''
  return /display\s*:\s*none/i.test(style)
}

// node 서브트리의 readReceipt 추적 픽셀 컨테이너를 분리해 saved에 모은다.
// display:none 으로 감싼 table 단위(있으면)로 보존하고, 없으면 img 자체를 보존한다.
function detachReadReceiptPixels(node, saved) {
  if (node.nodeType !== 1) {
    return
  }
  var containers = []
  if (node.matches != null && node.matches(READ_RECEIPT_IMG_SELECTOR)) {
    containers.push(node)
  } else if (node.querySelectorAll != null) {
    var imgs = node.querySelectorAll(READ_RECEIPT_IMG_SELECTOR)
    for (var i = 0; i < imgs.length; i++) {
      var container = imgs[i]
      var parent = imgs[i].parentElement
      while (parent != null && parent !== node) {
        if (isHiddenTable(parent)) {
          container = parent
          break
        }
        parent = parent.parentElement
      }
      containers.push(container)
    }
  }
  for (var j = 0; j < containers.length; j++) {
    if (containers[j].parentNode != null) {
      containers[j].parentNode.removeChild(containers[j])
    }
    saved.push(containers[j])
  }
}

// element 자식 인덱스 경로. 패딩은 텍스트 노드만 추가하므로 element 인덱스는
// 패딩본(scratch)과 clean 복사본에서 동일하다 → 경계를 안전하게 매핑할 수 있다.
function elementPath(element, root) {
  var path = []
  var current = element
  var parent, index
  while (current !== root && current.parentNode != null) {
    parent = current.parentNode
    index = Array.prototype.indexOf.call(parent.children, current)
    if (index < 0) {
      return null
    }
    path.unshift(index)
    current = parent
  }
  return current === root ? path : null
}

function elementAtPath(root, path) {
  var current = root
  for (var i = 0; i < path.length; i++) {
    if (current.children == null || path[i] >= current.children.length) {
      return null
    }
    current = current.children[path[i]]
  }
  return current
}

// startNode부터 문서 끝까지 구조적으로 제거(형제→상위의 다음 형제→반복).
// 제거 대상에 포함된 추적 픽셀은 분리해 두었다가 body 말단에 재부착한다.
function cutForwardToEnd(emailBody, startNode) {
  var saved = []
  var current = startNode
  var node, next, temp, i
  while (current != null) {
    node = current
    next = node.nextSibling
    if (next == null) {
      temp = node
      do {
        temp = temp.parentElement
      } while (temp != null && temp !== emailBody && temp.nextSibling == null)
      if (temp != null && temp !== emailBody) {
        next = temp.nextSibling
      }
    }
    detachReadReceiptPixels(node, saved)
    if (node.parentNode != null) {
      node.parentNode.removeChild(node)
    }
    current = next
  }
  for (i = 0; i < saved.length; i++) {
    emailBody.appendChild(saved[i])
  }
}

// 인용 시작부터 문서 끝까지 구조적으로 제거한다.
// 경계 탐색은 패딩이 필요하므로 scratchBody(패딩 가능한 별도 복사본)에서 수행하고,
// 실제 제거는 패딩하지 않은 cleanBody에 element-path로 매핑해 적용한다.
// → 답장(인용 밖) 부분의 공백/구조가 원본 그대로 보존된다.
export function cutQuotationToEnd(cleanBody, scratchBody, quotationCheckpoints) {
  var first = findFirstQuotationNode(scratchBody, { counter: 0 }, quotationCheckpoints)
  if (first == null) {
    return
  }
  var startScratch = highestQuotationStart(first, scratchBody)
  if (startScratch.nodeType === 1) {
    var path = elementPath(startScratch, scratchBody)
    var startClean = path != null ? elementAtPath(cleanBody, path) : null
    if (startClean != null) {
      cutForwardToEnd(cleanBody, startClean)
      return
    }
  }
  // 폴백(인용 시작이 element로 매핑 불가한 드문 경우): cleanBody에서 직접 경계를 찾아 제거.
  var firstClean = findFirstQuotationNode(cleanBody, { counter: 0 }, quotationCheckpoints)
  if (firstClean == null) {
    return
  }
  cutForwardToEnd(cleanBody, highestQuotationStart(firstClean, cleanBody))
}

export function cutGmailQuote(emailDocument) {
  var nodesArray
  nodesArray = emailDocument.getElementsByClassName('gmail_quote')
  if (!(nodesArray.length > 0)) {
    return false
  }
  removeNodes(nodesArray)
  return true
}

export function cutMicrosoftQuote(emailDocument) {
  var afterSplitter, parentElement, splitterElement
  splitterElement = findMicrosoftSplitter(emailDocument)
  if (splitterElement == null) {
    return false
  }
  parentElement = splitterElement.parentElement
  afterSplitter = splitterElement.nextElementSibling
  while (afterSplitter != null) {
    parentElement.removeChild(afterSplitter)
    afterSplitter = splitterElement.nextElementSibling
  }
  parentElement.removeChild(splitterElement)
  return true
}

// 기존 XPath `(.//blockquote)[not(ancestor::blockquote)][last()]`를
// querySelectorAll + JS ancestor 검사로 대체. document-order 보존되므로
// 마지막 "외부" blockquote를 찾는 의미가 동일하다.
export function cutBlockQuote(emailDocument) {
  var all, i, bq
  all = emailDocument.querySelectorAll('blockquote')
  for (i = all.length - 1; i >= 0; i--) {
    bq = all[i]
    if (!hasAncestorWithTagName(bq, 'blockquote')) {
      bq.parentElement.removeChild(bq)
      return true
    }
  }
  return false
}

function hasAncestorWithTagName(element, tagName) {
  var parent = element.parentElement
  while (parent != null) {
    if (parent.tagName.toLowerCase() === tagName) {
      return true
    }
    parent = parent.parentElement
  }
  return false
}

export function cutById(emailDocument) {
  var found, i, len, quoteElement, quoteId
  found = false
  for (i = 0, len = QUOTE_IDS.length; i < len; i++) {
    quoteId = QUOTE_IDS[i]
    quoteElement = emailDocument.getElementById(quoteId)
    if (quoteElement != null) {
      found = true
      quoteElement.parentElement.removeChild(quoteElement)
    }
  }
  return found
}

export function cutFromBlock(emailDocument) {
  var afterSplitter,
    fromBlock,
    firstBlock,
    parentDiv,
    ref,
    splitterElement,
    textNode,
    xpathQuery,
    xpathResult,
    bodyText
  // 사전 필터: 본문에 'From:'/'Date:' 문자열이 없다면 XPath(normalize-space)를
  // 전체 DOM에 돌릴 필요가 없다. false-positive가 있어도 정확성엔 영향 없음(성능만).
  bodyText = emailDocument.body != null ? emailDocument.body.textContent || '' : ''
  if (bodyText.indexOf('From:') < 0 && bodyText.indexOf('Date:') < 0) {
    return false
  }
  xpathQuery =
    "//*[starts-with(normalize-space(.), 'From:')]|//*[starts-with(normalize-space(.), 'Date:')]"
  xpathResult = emailDocument.evaluate(xpathQuery, emailDocument, null, 5, null)

  fromBlock = xpathResult.iterateNext()
  firstBlock = fromBlock

  if (firstBlock != null) {
    parentDiv = findParentDiv(firstBlock)
    if (parentDiv != null && !elementIsAllContent(parentDiv)) {
      var curNode = parentDiv
      while (curNode != null) {
        var node = curNode
        curNode = node.nextSibling
        if (curNode == null) {
          var temp = node
          do {
            temp = temp.parentElement
          } while (temp != null && temp !== emailDocument.body && temp.nextSibling == null)

          if (temp != null && temp !== emailDocument.body) {
            curNode = temp.nextSibling
          }
        }
        node.parentElement.removeChild(node)
      }

      return true
    }
  }
  xpathQuery =
    "//text()[starts-with(normalize-space(.), 'From:')]|//text()[starts-with(normalize-space(.), 'Date:')]"
  xpathResult = emailDocument.evaluate(xpathQuery, emailDocument, null, 9, null)
  textNode = xpathResult.singleNodeValue
  if (textNode == null) {
    return false
  }
  if (isTextNodeWrappedInSpan(textNode)) {
    return false
  }
  splitterElement = textNode.previousSibling
  if (splitterElement != null) {
    if ((ref = splitterElement.parentElement) != null) {
      ref.removeChild(splitterElement)
    }
  }
  afterSplitter = textNode.nextSibling
  while (afterSplitter != null) {
    afterSplitter.parentNode.removeChild(afterSplitter)
    afterSplitter = textNode.nextSibling
  }
  textNode.parentNode.removeChild(textNode)
  return true
}

function findParentDiv(element) {
  while (element != null && element.parentElement != null) {
    if (hasTagName(element, 'div') || hasTagName(element, 'p')) {
      return element
    } else {
      element = element.parentElement
    }
  }
  return null
}

function elementIsAllContent(element) {
  var maybeBody
  maybeBody = element.parentElement
  return maybeBody != null && hasTagName(maybeBody, 'body') && maybeBody.childNodes.length === 1
}

function isTextNodeWrappedInSpan(textNode) {
  var parentElement
  parentElement = textNode.parentElement
  return (
    parentElement != null &&
    hasTagName(parentElement, 'span') &&
    parentElement.childNodes.length === 1
  )
}

// body.innerHTML 전체를 재파싱하여 <br> → '\n'으로 치환한다.
// 재파싱이 HTML 파서 정규화와 인접 TextNode 병합이라는 부수효과를 수반하는데,
// 후속 단계(line 단위 분석)가 이 정규화된 상태를 전제로 동작하므로 기존 방식을 유지한다.
// body 레벨 1회 호출이므로 전체 성능에 미치는 영향은 제한적이다.
var BREAK_TAG_REGEX = new RegExp('<br\\s*[/]?>', 'gi')

export function replaceBreakTagsWithLineFeeds(emailDocument) {
  var body, currentHtml
  body = emailDocument.body
  if (body == null) {
    return
  }
  currentHtml = body.innerHTML
  body.innerHTML = currentHtml.replace(BREAK_TAG_REGEX, '\n')
}

var OUTLOOK_SPLITTER_QUERY_SELECTORS = {
  outlook2007: "div[style='border:none;border-top:solid #B5C4DF 1.0pt;padding:3.0pt 0cm 0cm 0cm']",
  outlookForAndroid:
    "div[style='border:none;border-top:solid #E1E1E1 1.0pt;padding:3.0pt 0cm 0cm 0cm']",
  windowsMail:
    "div[style='padding-top: 5px; border-top-color: rgb(229, 229, 229); border-top-width: 1px; border-top-style: solid;']",
}

var OUTLOOK_XPATH_SPLITTER_QUERIES = {
  outlook2003:
    "//div/div[@class='MsoNormal' and @align='center' and @style='text-align:center']/font/span/hr[@size='3' and @width='100%' and @align='center' and @tabindex='-1']",
}

var OUTLOOK_SPLITTER_QUOTE_IDS = {
  office365: '#divRplyFwdMsg',
}

var DOCUMENT_POSITION_PRECEDING = 2
var DOCUMENT_POSITION_FOLLOWING = 4

function findMicrosoftSplitter(emailDocument) {
  var _, possibleSplitterElements, querySelector, quoteId, splitterElement, xpathQuery
  possibleSplitterElements = []
  for (_ in OUTLOOK_SPLITTER_QUERY_SELECTORS) {
    querySelector = OUTLOOK_SPLITTER_QUERY_SELECTORS[_]
    if ((splitterElement = findOutlookSplitterWithQuerySelector(emailDocument, querySelector))) {
      possibleSplitterElements.push(splitterElement)
    }
  }
  for (_ in OUTLOOK_XPATH_SPLITTER_QUERIES) {
    xpathQuery = OUTLOOK_XPATH_SPLITTER_QUERIES[_]
    if ((splitterElement = findOutlookSplitterWithXpathQuery(emailDocument, xpathQuery))) {
      possibleSplitterElements.push(splitterElement)
    }
  }
  for (_ in OUTLOOK_SPLITTER_QUOTE_IDS) {
    quoteId = OUTLOOK_SPLITTER_QUOTE_IDS[_]
    if ((splitterElement = findOutlookSplitterWithQuoteId(emailDocument, quoteId))) {
      possibleSplitterElements.push(splitterElement)
    }
  }
  if (!possibleSplitterElements.length) {
    return null
  }
  return possibleSplitterElements.sort(compareByDomPosition)[0]
}

function compareByDomPosition(elementA, elementB) {
  var documentPositionComparison
  documentPositionComparison = elementA.compareDocumentPosition(elementB)
  if (documentPositionComparison & DOCUMENT_POSITION_PRECEDING) {
    return 1
  } else if (documentPositionComparison & DOCUMENT_POSITION_FOLLOWING) {
    return -1
  }
  return 0
}

function findOutlookSplitterWithXpathQuery(emailDocument, xpathQuery) {
  var splitterElement, xpathResult
  xpathResult = emailDocument.evaluate(xpathQuery, emailDocument, null, 9, null)
  splitterElement = xpathResult.singleNodeValue
  if (splitterElement != null) {
    splitterElement = splitterElement.parentElement.parentElement
    splitterElement = splitterElement.parentElement.parentElement
  }
  return splitterElement
}

function findOutlookSplitterWithQuerySelector(emailDocument, query) {
  var splitterElement, splitterResult
  splitterResult = emailDocument.querySelectorAll(query)
  if (!(splitterResult.length > 1)) {
    return
  }
  splitterElement = splitterResult[1]
  if (
    splitterElement.parentElement != null &&
    splitterElement === splitterElement.parentElement.children[0]
  ) {
    splitterElement = splitterElement.parentElement
  }
  return splitterElement
}

function findOutlookSplitterWithQuoteId(emailDocument, id) {
  var splitterResult
  splitterResult = emailDocument.querySelectorAll(id)
  if (!splitterResult.length) {
    return
  }
  return splitterResult[0]
}

function removeNodes(nodesArray) {
  var i, index, node, ref, ref1, results
  results = []
  for (
    index = i = ref = nodesArray.length - 1;
    ref <= 0 ? i <= 0 : i >= 0;
    index = ref <= 0 ? ++i : --i
  ) {
    node = nodesArray[index]
    results.push(
      node != null ? ((ref1 = node.parentNode) != null ? ref1.removeChild(node) : void 0) : void 0,
    )
  }
  return results
}

function ensureTextNodeBetweenChildElements(element) {
  var currentNode, dom, newTextNode, results
  dom = element.ownerDocument
  currentNode = element.childNodes[0]
  if (!currentNode) {
    newTextNode = dom.createTextNode(' ')
    element.appendChild(newTextNode)
    return
  }
  results = []
  while (currentNode.nextSibling) {
    if (currentNode.nodeType === 1 && currentNode.nextSibling.nodeType === 1) {
      newTextNode = dom.createTextNode(' ')
      element.insertBefore(newTextNode, currentNode.nextSibling)
    }
    results.push((currentNode = currentNode.nextSibling))
  }
  return results
}

function hasTagName(element, tagName) {
  return element.tagName.toLowerCase() === tagName
}
